import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cachedNumber = null;

export const useWhatsAppNumber = () => {
  const [number, setNumber] = useState(cachedNumber || "");
  useEffect(() => {
    if (cachedNumber) return;
    api.get("/config/whatsapp").then((r) => {
      cachedNumber = r.data.number || "";
      setNumber(cachedNumber);
    }).catch(() => {});
  }, []);
  return number;
};

export const buildWaLink = (number, message) => {
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${number}?text=${encoded}`;
};
